'use client';

import React from 'react';
import { NoticesContext } from './NoticesContext';
import { useNotices } from '../../hooks/useNotices';

export const NoticesProvider = ({ children }) => {
  return (
    <NoticesContext.Provider value={useNotices()}>
      {children}
    </NoticesContext.Provider>
  );
};
